<template>
    <div class="box-two proerty-item">
        <div class="item-thumb">
            <router-link :to="getAgencyDetailUrl()"><img width="100" height="90" :src="agency.picture_url" :alt="agency.name" onerror="this.src='/template/assets/img/user-icon.png'"></router-link>
        </div>

        <div class="item-entry overflow ">
            <h5><router-link :to="getAgencyDetailUrl()"> {{agency.name}} </router-link></h5>
            <div class="dot-hr"></div>
            <span class="pull-left"><b> Address :</b> {{agency.address}} </span>
            <div class="property-icon">
                <a :href="agency.facebook" target="_blank"><span v-if="agency.facebook" class="fa fa-facebook"></span></a>
                <a :href="agency.twitter" target="_blank"><span v-if="agency.twitter" class="fa fa-twitter"></span></a>
                <a :href="agency.google" target="_blank"><span v-if="agency.google" class="fa fa-google"></span></a>
            </div>
        </div>
    </div>
</template>

<script>
import {slugify} from "../../api/helpers";

export default {
    name: "AgencyTemplate",
    props: ["agency"],
    setup(props, context) {

        const getAgencyDetailUrl= function () {
            return `/agency/${props.agency.id}/${slugify(props.agency.name)}`;
        }

        return {
            getAgencyDetailUrl
        }
    }
}
</script>

<style scoped>
.item-thumb {
    position: relative;
}

.property-icon span {
    margin: 5px;
}

.proerty-th-list .col-md-4 .item-thumb {
    width: 25%;
}

.proerty-th-list .col-md-4 .item-thumb img {
    height: 148px;
}
</style>
